<template>
  <b-row class="mt-5">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-col cols="12">
      <label class="float-left ">Adjuntar evidencias *</label>
      <b-button class="float-right" size="sm" variant="danger" v-b-modal="'modal-add_file'+padre">
        <font-awesome-icon icon="upload"/>
      </b-button>
      <b-modal
          ok-title="Aceptar"
          cancel-title="Cerrar"
          size="xl" hide-footer :id="'modal-add_file'+padre" title="Agregar archivos">
        <SubirArchivo v-on:archivo="appendArchivo" :padre="padre" :paciente="paciente"></SubirArchivo>
      </b-modal>
    </b-col>
    <b-col cols="12">
      <ListarArchivos :show-delete="true" v-on:archivos="relistar" :archivos.sync="archivos"></ListarArchivos>
    </b-col>
  </b-row>
</template>

<script>
import ListarArchivos from "./ListarArchivos";
import SubirArchivo from "./SubirArchivo";

export default {
  name: "BotonYListaSubirArchivos",
  components: {SubirArchivo, ListarArchivos},
  props: {
    padre: String,
    paciente: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    archivos: [],
  }),
  mounted() {
    this.$root.$on('archivos', (archivos)=> {
      this.archivos = archivos
    })
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    relistar(archivos) {
      this.archivos = archivos;
      this.$emit('archivos', archivos)
    },
    appendArchivo(archivo) {
      this.archivos.push(archivo);
      this.$emit('archivos', this.archivos)
    },
  }
}
</script>

<style scoped>

</style>
